export enum ShippingChronoUnit {
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS'
}
export interface ShippingDTO {
  chronoUnit?: ShippingChronoUnit
  countries: string[]
  currency: string
  deliveryTime?: string
  freeAmount: number
  freeShipping: boolean
  freeShippingAbove: boolean
  id: number
  name: string
  price: number
  active?: boolean
}
